<mat-checkbox class="table-check"
              color="{{color}}"
              [(ngModel)]="valore"
              [disabled]="block ? block : false"
              (ngModelChange)="valueChange($event)">
    {{testo}}
</mat-checkbox>
